import { Column } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { type Profile } from 'app/network/profile';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Pressable } from 'react-native';
import { theme } from './theme';

export function ProfileBio({ profile }: { profile: Profile | undefined }) {
  const { t } = useTranslation('accordion');
  const [expanded, setExpanded] = useState(false);
  const [truncated, setTruncated] = useState(false);
  if (!profile?.bio) return null;
  return (
    <Column style={{ gap: 4 }}>
      <Text
        accessible={false}
        accessibilityElementsHidden
        importantForAccessibility="no-hide-descendants"
        onTextLayout={(event) => setTruncated(event.nativeEvent.lines.length > 2)}
        variant="bodyBase"
        style={{ position: 'absolute', opacity: 0, width: '100%', lineHeight: 20 }}
      >
        {profile.bio}
      </Text>
      <Text variant="bodyBase" color="text.primary" numberOfLines={expanded ? undefined : 2} style={{ lineHeight: 20 }}>
        {profile.bio}
      </Text>
      {truncated ? (
        <Pressable
          accessibilityRole="button"
          accessibilityState={{ expanded }}
          hitSlop={8}
          style={
            !expanded
              ? {
                  position: 'absolute',
                  bottom: 0,
                  right: 0,
                  backgroundColor: theme.colors['surface.default'],
                  paddingLeft: 4,
                }
              : undefined
          }
          onPress={() => setExpanded(!expanded)}
        >
          <Text variant="bodySmall" color="text.brand" fontWeight="600" style={{ textDecorationLine: 'underline' }}>
            {t(expanded ? 'showLess' : 'showMore')}
          </Text>
        </Pressable>
      ) : null}
    </Column>
  );
}
